
'use client'
import React from 'react'
import styled from 'styled-components'

const PreviewContainer = styled.div`
    width: 100%;
    height: 100%;
    background: #0a0f1865; /* Deeper dark background */
    background-image: radial-gradient(circle at center, rgba(99, 102, 241, 0.05) 0%, transparent 70%);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
`;

const GunContainer = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    overflow: hidden;
    perspective: 400px;
`;

const GunWrapper = styled.div`
    transform: ${({ $transform }) => $transform};
    display: flex;
    flex-direction: column;
    align-items: center;
    transform-origin: 50% 100%;
`;

const SimpleGunBox = styled.div`
    width: 40px;
    height: 75px;
    background: linear-gradient(180deg, #334155 0%, #1e293b 100%);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.6);
    position: relative;
    margin-bottom: -24px;
    transition: transform 0.2s cubic-bezier(0.2, 0.8, 0.2, 1);

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 2px;
        height: 6px;
        background: rgba(255, 255, 255, 0.2);
    }
`;

const parseCommands = (str) => {
    const params = { x: 1, y: 1, z: -1, fov: 60 };
    if (!str) return params;

    str.split(';').forEach(cmd => {
        const parts = cmd.trim().split(' ');
        if (parts.length < 2) return;
        const key = parts[0];
        const val = parseFloat(parts[1]);
        if (key === 'viewmodel_offset_x') params.x = val;
        if (key === 'viewmodel_offset_y') params.y = val;
        if (key === 'viewmodel_offset_z') params.z = val;
        if (key === 'viewmodel_fov') params.fov = val;
    });
    return params;
};

const ViewmodelMiniPreview = ({ commands }) => {
    const vm = parseCommands(commands);

    // Sync with main module formula: Centered at x = -2.5
    const pixelX = (vm.x + 2.5) * 15
    const pixelY = -vm.z * 3
    const fovScale = 1 - (vm.fov - 60) * 0.02
    const depthScale = 1 - vm.y * 0.05
    const totalScale = fovScale * depthScale
    const scaleYComp = totalScale > 1 ? (totalScale - 1) * 70 : (totalScale - 1) * 30
    const depthTranslateY = -vm.y * 3

    const finalTransform = `translate(${pixelX}px, ${pixelY + depthTranslateY + scaleYComp}px) scale(${totalScale})`

    return (
        <PreviewContainer>
            <GunContainer>
                <GunWrapper $transform={finalTransform}>
                    <SimpleGunBox />
                </GunWrapper>
            </GunContainer>
        </PreviewContainer>
    );
};

export default ViewmodelMiniPreview;
